<div class="modal-header">
  <h3 class="modal-title">You have unsaved changes</h3>
  <button
    type="button"
    class="btn-close"
    aria-label="Close"
    data-testid="modal_close_btn"
    (click)="onCancelSave()"
  ></button>
</div>

<div class="modal-body">
  @if (options?.data?.leavingPage) {
    <p>If you leave this page your changes will be lost.</p>
  } @else {
    <p>You need to save or discard changes before proceeding.</p>
  }
</div>

<div class="modal-footer justify-content-start">
  <div class="d-flex gap-3">
    <button
      type="button"
      class="btn btn-colour-blue-600"
      data-testid="save-btn"
      (click)="onSaveChanges()"
    >
      Save
    </button>
    <button
      type="button"
      class="btn btn-colour-white border-colour-grayscale-900"
      data-testid="cancel-btn"
      (click)="onDontSaveChanges()"
    >
      Don't save
    </button>
  </div>
</div>
